<template>
  <div class="context-items-wrapper">
    <BbBtn v-for="tactic in tacticContextFilters" :key="tactic.id" size="large" type="secondary">
      {{ tactic.regionDescriptionName }}, {{ tactic.name }}
      <BbBtn
        size="x-small"
        type="icon"
        icon="x-small"
        icon-size="medium"
        no-background
        @click="onRemoveTacticContext(tactic)"
      />
    </BbBtn>
  </div>
</template>

<script>
import useAuthoring from '~/composables/useAuthoring';

export default {
  name: 'TacticItemsStyles',

  setup() {
    const { tacticContextFilters, setTacticContextFilters } = useAuthoring();

    const onRemoveTacticContext = (tacticContext) => {
      setTacticContextFilters({ contextTypeId: tacticContext.contextTypeId, tacticContext });
    };

    return {
      tacticContextFilters,
      onRemoveTacticContext,
    };
  },
};
</script>

<style lang="scss" scoped>
.context-items-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: fit-content;

  .bb-btn.secondary {
    width: fit-content;

    &:hover {
      background: transparent;
      cursor: initial;
    }

    :deep(.v-btn__content) {
      display: flex;
      align-items: center;

      div {
        font-weight: 500;
        color: #1c1c1d;
      }

      .bb-btn.icon {
        &:hover {
          background: transparent;
        }

        i {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
